module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1fda5ce0db64be6d3a9c741a1298e6dd.1fda5ce0.png";